import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { useMarketingCopy } from '../context/MarketingCopyContext';
import { localizedPath } from '../utils/routes';

export default function Footer() {
  const { language, t } = useLanguage();
  const { mc } = useMarketingCopy();
  const { lang } = useParams();
  const currentLang = lang || language;
  const lp = (routeName) => localizedPath(routeName, currentLang);
  const phone1 = mc('contact', 'phone1', t.business.phone);
  const phone2 = mc('contact', 'phone2', t.business.phone2);

  const navLinks = [
    ['home', t.nav.home],
    ['services', t.nav.services],
    ['about', t.nav.about],
    ['contact', t.nav.contact],
    ['faq', t.nav.faq],
    ['gallery', t.nav.gallery],
    ['privacy', t.nav.privacy],
    ['terms', t.nav.terms]
  ];

  const servicesList = t.footer.servicesList;

  return (
    <footer style={{
      background: '#080E1A', borderTop: '1px solid rgba(148,163,184,0.15)',
      padding: 'clamp(2rem, 4vw, 4rem) clamp(1rem, 3vw, 3rem) 2rem', marginTop: '4rem'
    }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div className="cjpa-footer-grid">

          {/* Company Info */}
          <div>
            <div style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: '1.8rem', color: '#E8ECF0', fontWeight: 700, marginBottom: '0.3rem' }}>CJPA</div>
            <div style={{ fontSize: '0.6rem', letterSpacing: '0.15em', color: '#64748B', textTransform: 'uppercase', marginBottom: '1.2rem' }}>{t.business.tagline}</div>
            <p style={{ color: '#94A3B8', fontSize: '0.8rem', lineHeight: 1.8, maxWidth: '280px', marginBottom: '1.5rem' }}>
              {t.footer.description}
            </p>
            <div style={{ color: '#64748B', fontSize: '0.75rem', lineHeight: 1.7 }}>
              <div style={{ marginBottom: '0.5rem' }}>
                <strong style={{ color: '#E8ECF0' }}>{t.business.address.split(',')[0]}</strong>
              </div>
              <div>{t.business.address.split(',').slice(1).join(',')}</div>
              <div style={{ marginTop: '0.8rem' }}>
                <a href={`tel:${phone1}`} style={{ color: '#D42B2B', textDecoration: 'none' }}>
                  {phone1}
                </a>
              </div>
              <div style={{ marginTop: '0.3rem' }}>
                <a href={`tel:${phone2}`} style={{ color: '#D42B2B', textDecoration: 'none' }}>
                  {phone2}
                </a>
              </div>
            </div>
          </div>

          {/* Navigate */}
          <div>
            <h4 style={{ color: '#D42B2B', fontSize: '0.65rem', letterSpacing: '0.15em', textTransform: 'uppercase', marginBottom: '1.2rem' }}>
              {t.footer.navigate}
            </h4>
            {navLinks.map(([routeName, label]) => (
              <div key={routeName} style={{ marginBottom: '0.6rem' }}>
                <Link to={lp(routeName)} style={{ color: '#94A3B8', textDecoration: 'none', fontSize: '0.8rem', letterSpacing: '0.05em', transition: 'color 0.3s' }}>
                  {label}
                </Link>
              </div>
            ))}
          </div>

          {/* Services */}
          <div>
            <h4 style={{ color: '#D42B2B', fontSize: '0.65rem', letterSpacing: '0.15em', textTransform: 'uppercase', marginBottom: '1.2rem' }}>
              {t.footer.services}
            </h4>
            {servicesList.map(s => (
              <div key={s} style={{ marginBottom: '0.6rem', color: '#94A3B8', fontSize: '0.8rem' }}>
                {s}
              </div>
            ))}
          </div>

          {/* Business Hours */}
          <div>
            <h4 style={{ color: '#D42B2B', fontSize: '0.65rem', letterSpacing: '0.15em', textTransform: 'uppercase', marginBottom: '1.2rem' }}>
              {t.business.hours.title}
            </h4>
            {[
              [t.business.hours.monday + ' – ' + t.business.hours.friday, t.business.hours.weekdaysTime],
              [t.business.hours.saturday, t.business.hours.saturdayTime],
              [t.business.hours.sunday, t.business.hours.sundayTime]
            ].map(([day, time]) => (
              <div key={day} style={{ marginBottom: '0.8rem' }}>
                <div style={{ color: '#64748B', fontSize: '0.72rem', letterSpacing: '0.05em' }}>{day}</div>
                <div style={{ color: time === t.business.hours.sundayTime ? '#b07070' : '#D42B2B', fontSize: '0.78rem' }}>{time}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Bar */}
        <div style={{ borderTop: '1px solid rgba(148,163,184,0.1)', paddingTop: '1.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1rem' }}>
          <div style={{ color: '#475569', fontSize: '0.72rem', letterSpacing: '0.05em' }}>
            {t.footer.rights}
          </div>
          <div style={{ display: 'flex', gap: '1.5rem', fontSize: '0.72rem' }}>
            <Link to={lp('privacy')} style={{ color: '#94A3B8', textDecoration: 'none' }}>{t.nav.privacy}</Link>
            <Link to={lp('terms')} style={{ color: '#94A3B8', textDecoration: 'none' }}>{t.nav.terms}</Link>
          </div>
          <div style={{ color: '#475569', fontSize: '0.72rem', letterSpacing: '0.05em' }}>
            {t.footer.excellence}
          </div>
        </div>
      </div>
    </footer>
  );
}
